export default __webpack_public_path__ + "static/fixedMenuInstaIcon-323b481cc11d37d633f0d443dec1bdbc.svg";